module.exports = __webpack_public_path__ + "img/Twitter.bee7f040.svg";